/**
 * External dependencies
 */
import React from 'react';
import { SVG, Path } from '@wordpress/primitives';

export default (
	<SVG
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<Path
			d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
			stroke="#F0B849"
			strokeWidth="1.5"
		/>
		<Path d="M13 7H11V13H13V7Z" fill="#F0B849" />
		<Path d="M13 15H11V17H13V15Z" fill="#F0B849" />
	</SVG>
);
